import { createContext, useContext } from "react";

export interface ToolbarLayerContextValue {
    tooltipsVisible: boolean;
    onFlyoutOpenChange: (open: boolean) => void;
}

export const ToolbarLayerContext = createContext<ToolbarLayerContextValue>({
    tooltipsVisible: false,
    onFlyoutOpenChange: () => {},
});

export function useToolbarLayer() {
    return useContext(ToolbarLayerContext);
}
